import ModalSelect from './modal_select';

export default ModalSelect;
